export default __webpack_public_path__ + "static/media/TrustWallet.30b907bc.svg";